import {api} from '../../../shared';
import {CreateFundDTO, FundDetailedModel, FundModel, FundWithMetaModel, FundsFilter, UpdateFundParams} from '../model';


export const fundsApi = {
  getFunds: async (params: FundsFilter = {}): Promise<FundWithMetaModel> => {
    const { pageSize = 10, after, ...restParams } = params;
    const queryParams = { 
      ...restParams, 
      includeTotalCount: true, 
      first: pageSize,
      ...(after && { after }),
    };

    const {data} = await api.get<FundWithMetaModel>('/api/fundraising/admin/funds', {params: queryParams});
    return data;
  },

  getFundById: async (fundId: string): Promise<FundDetailedModel> => {
    const {data} = await api.get<FundDetailedModel>(`/api/fundraising/admin/funds/${fundId}`);
    return data;
  },

  createFund: async (fund: CreateFundDTO): Promise<FundModel> => {
    const {data} = await api.post<FundModel>('/api/fundraising/admin/funds', fund);
    return data;
  },
  
  // Добавляем метод для обновления фонда
  updateFund: async ({fundId, data}: UpdateFundParams): Promise<FundModel> => {
    const {data: responseData} = await api.put<FundModel>(`/api/fundraising/admin/funds/${fundId}`, data);
    return responseData;
  },
  
  uploadFundAvatar: async (fundId: string, payload: Record<string, any>) => {
    const {data} = await api.post<void>(`/api/fundraising/admin/funds/${fundId}/avatar`, payload);
    return data;
  },

  deleteFundAvatar: async (fundId: string) => {
    const {data} = await api.delete<void>(`/api/fundraising/admin/funds/${fundId}/avatar`);
    return data;
  },
  
  deleteFund: async (fundId: string) => {
    const {data} = await api.delete<void>(`/api/fundraising/admin/funds/${fundId}`);
    return data;
  },
}; 